/**
 * TELL ME WHEN — the phone's bottom sheet (DESIGN-CHANGELOG 2026-09-03;
 * `design/GT Mobile Mine.dc.html:348-410`). AA phase 4.
 *
 * The desktop modal stacked: 104×49 art, seven 52px rows with a divider, the
 * PRICE row's 36px stepper cells, `ALSO PUT IT ON MY BACKLOG`, then two equal
 * 44px halves — CANCEL / SAVE ▸. Root-mounted; edits a draft.
 */

import { CoverArt } from '../components/CoverArt.tsx';
import { Sheet } from '../components/Sheet.tsx';
import { useArt } from '../components/useArt.ts';
import { useQd } from '../store/index.ts';
import { tellMeWhenVM } from '../store/selectors.ts';

const MONO = 'var(--gt-font-mono)';

export default function TellMeWhenSheet(): JSX.Element {
  const s = useQd();
  const v = tellMeWhenVM(s);
  const art = useArt(v.id + 'w', v.hdrCands);

  return (
    <Sheet
      onClose={() => s.closeWatch()}
      label="Tell me when sheet"
      maxHeight="90vh"
      zIndex={85}
      header={{ title: 'TELL ME WHEN', titleClr: 'var(--gt-text)', titleFs: '9.5px', note: 'ONLY WHAT YOU ARM REACHES YOU' }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px', borderBottom: '1px solid var(--gt-line)' }}>
        <div style={{ position: 'relative', width: 104, height: 49, flex: 'none', background: v.fall, overflow: 'hidden', border: '1px solid var(--gt-line)' }}>
          <CoverArt style={{ position: 'absolute', inset: 0 }} fs={10} ini={v.ini} hasCover={art.hasCover} cover={art.cover} />
        </div>
        <div style={{ minWidth: 0, display: 'flex', flexDirection: 'column', gap: 5 }}>
          <span style={{ fontFamily: 'var(--gt-font-sans)', fontWeight: 600, fontSize: 14, color: 'var(--gt-text)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{v.n}</span>
          <span style={{ fontFamily: MONO, fontSize: 8.5, letterSpacing: '.07em', color: 'var(--gt-faint)' }}>{v.dev}</span>
          <div style={{ display: 'flex', gap: 6 }}>
            {v.stateChip ? (
              <span style={{ fontFamily: MONO, fontSize: 7.5, letterSpacing: '.08em', color: 'var(--gt-info)', border: '1px solid var(--gt-info)', padding: '2px 5px' }}>{v.stateChip}</span>
            ) : null}
            <span style={{ fontFamily: MONO, fontSize: 7.5, letterSpacing: '.08em', color: 'var(--gt-text-4)', border: '1px solid var(--gt-border-2)', padding: '2px 5px' }}>{v.priceChip}</span>
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {v.rows.map((r) => (
          <div
            key={r.key}
            onClick={() => (r.na ? undefined : s.wTog(r.k))}
            style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '8px 14px', minHeight: 52, boxSizing: 'border-box', borderBottom: '1px solid var(--gt-line-0)', background: r.rowBg, cursor: r.cur }}
          >
            <span
              style={{
                width: 20,
                height: 20,
                flex: 'none',
                boxSizing: 'border-box',
                border: '1px ' + r.boxBs + ' ' + r.boxBd,
                background: r.on ? 'var(--acc)' : 'transparent',
                display: 'grid',
                placeItems: 'center',
                fontFamily: MONO,
                fontSize: 11,
                color: r.on ? 'var(--gt-ink)' : 'var(--gt-ghost)',
              }}
            >
              {r.on ? '■' : r.na ? '–' : ''}
            </span>
            <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 3 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontFamily: MONO, fontSize: 10.5, letterSpacing: '.06em', color: r.labClr }}>{r.l}</span>
                {r.hasWarn ? (
                  <span style={{ fontFamily: MONO, fontSize: 7.5, letterSpacing: '.09em', color: 'var(--acc2)', background: 'var(--acc2Soft)', border: '1px solid var(--acc2)', padding: '2px 5px' }}>THE NOISY ONE</span>
                ) : null}
              </div>
              <span style={{ fontFamily: MONO, fontSize: 8.5, letterSpacing: '.05em', color: r.subClr, textWrap: 'pretty' }}>{r.sub}</span>
            </div>
            {r.isPrice && !r.na ? (
              <div onClick={(ev) => ev.stopPropagation()} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4, flex: 'none' }}>
                <div style={{ display: 'flex', border: '1px solid var(--gt-border-2)' }}>
                  <span onClick={() => s.wCap(-1)} style={{ width: 36, height: 36, display: 'grid', placeItems: 'center', fontFamily: MONO, fontSize: 13, color: 'var(--gt-text-4)', cursor: 'pointer' }}>−</span>
                  <span style={{ minWidth: 40, height: 36, display: 'grid', placeItems: 'center', fontFamily: MONO, fontSize: 11, color: 'var(--gt-text)', borderLeft: '1px solid var(--gt-border-2)', borderRight: '1px solid var(--gt-border-2)', padding: '0 4px' }}>{v.capTxt}</span>
                  <span onClick={() => s.wCap(1)} style={{ width: 36, height: 36, display: 'grid', placeItems: 'center', fontFamily: MONO, fontSize: 13, color: 'var(--gt-text-4)', cursor: 'pointer' }}>+</span>
                </div>
                {v.hasCapPct ? <span style={{ fontFamily: MONO, fontSize: 8, letterSpacing: '.06em', color: 'var(--gt-faint)' }}>{v.capPct} OFF</span> : null}
              </div>
            ) : null}
          </div>
        ))}
      </div>

      {v.alsoShown ? (
        <div onClick={() => s.wAlsoTog()} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '0 14px', minHeight: 44, fontFamily: MONO, fontSize: 9.5, letterSpacing: '.07em', color: v.also ? 'var(--acc)' : 'var(--gt-text-5)', cursor: 'pointer' }}>
          <span style={{ width: 16, height: 16, boxSizing: 'border-box', border: '1px solid ' + (v.also ? 'var(--acc)' : 'var(--gt-border-2)'), background: v.also ? 'var(--acc)' : 'transparent', display: 'grid', placeItems: 'center', fontSize: 10, color: 'var(--gt-ink)' }}>
            {v.also ? '✓' : ''}
          </span>
          ALSO PUT IT ON MY BACKLOG
        </div>
      ) : null}

      <div style={{ display: 'flex', gap: 8, padding: '10px 14px', paddingBottom: 'calc(10px + env(safe-area-inset-bottom))', borderTop: '1px solid var(--gt-line)', background: 'var(--gt-raised)' }}>
        <div onClick={() => s.closeWatch()} style={{ flex: 1, height: 44, display: 'grid', placeItems: 'center', fontFamily: MONO, fontSize: 10, letterSpacing: '.07em', color: 'var(--gt-text-5)', border: '1px solid var(--gt-border-2)', cursor: 'pointer', boxSizing: 'border-box' }}>
          CANCEL
        </div>
        <div onClick={() => void s.wSave()} style={{ flex: 1, height: 44, display: 'grid', placeItems: 'center', fontFamily: 'var(--gt-font-pixel)', fontSize: 8.5, color: 'var(--gt-ink)', background: 'var(--acc)', border: '1px solid var(--acc)', cursor: 'pointer', boxSizing: 'border-box' }}>
          <span style={{ transform: 'translateY(0.13em)' }}>{v.saveL}</span>
        </div>
      </div>
    </Sheet>
  );
}
